var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.592 0 0 3.592 0 8C0 12.408 3.592 16 8 16C12.408 16 16 12.408 16 8C16 3.592 12.408 0 8 0ZM7.20288 6.39922V3.99922C7.20288 3.55922 7.56288 3.19922 8.00288 3.19922C8.44288 3.19922 8.80288 3.55922 8.80288 3.99922V6.39922H10.2349C10.5949 6.39922 10.7709 6.83122 10.5149 7.07922L8.28288 9.31122C8.12288 9.47122 7.87488 9.47122 7.71488 9.31122L5.48288 7.07922C5.23488 6.83122 5.41088 6.39922 5.77088 6.39922H7.20288ZM11.2 11.9984H4.8C4.36 11.9984 4 11.6384 4 11.1984C4 10.7584 4.36 10.3984 4.8 10.3984H11.2C11.64 10.3984 12 10.7584 12 11.1984C12 11.6384 11.64 11.9984 11.2 11.9984Z",
    fill: "#6021B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPurple);
export default __webpack_public_path__ + "static/media/download-purple.52bc4fa6fe8998a18b366b62c6b7ad62.svg";
export { ForwardRef as ReactComponent };